(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["content-review-cards"] && !window.DesignMode) return;
  try {
    
    var content_cards_carousel = jQuery('.reviews .row');
    if(content_cards_carousel.length > 0 ) {
        content_cards_carousel.not('.slick-initialized').slick({
          slidesToShow: 2,
          slidesToScroll: 1,
          touchMove: true,
          arrows: true,
          dots: true,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });
    };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-feature-carousel"] && !window.DesignMode) return;
  try {
    
  Helpers.loadScript('https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js', function() {
    /* script loaded */
    var product_feature_carousel = jQuery('.carousel.product-feature .carousel-container');
    product_feature_carousel.not('.slick-initialized').slick({
      slidesToShow: product_feature_carousel.data('slides-to-show'),
      slidesToScroll: product_feature_carousel.data('slides-to-show'),
      touchMove: false,
      arrows: product_feature_carousel.data('arrows'),
      dots: product_feature_carousel.data('dots'),
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-header"]) return;
  try {
    

  var selectedVariantId = jQuery('[variant-select] option:selected').val();
  var productObj = JSON.parse(document.getElementById('ProductJson').innerHTML);
  var variantObj = getCurrentVariant( selectedVariantId );
  var upsell_continue = false;



  function htmlDecode(input) {
    var doc = new DOMParser().parseFromString(input, "text/html");
    return doc.documentElement.textContent;
  };

  function updatePrice() {
    var productPrice = variantObj.price;
    var originalPrice = variantObj.compare_at_price;
    var variantId = variantObj.id;

    var description_swap = jQuery('#product_body_box').data('description-swap');

    if( description_swap.length > 0 ) {
      var variant_description = htmlDecode(description_swap[variantId]);

      if( variant_description && variant_description.length > 0 ) {
        jQuery('#product_body_box').html( variant_description );
      }
    }

    // set proper format and update price UI
    jQuery('.product-header [product-price]').html( Shopify.formatMoney(productPrice) );
    if (jQuery('button[type="submit"] span:contains("$")').length > 0) {
      jQuery('button[type="submit"] span').html( 'Add to Cart - '+ Shopify.formatMoney(productPrice) );
    };
    // If variant is on sale, update sale pricing UI
    if ( productPrice < originalPrice ) {
      jQuery('.product-header [original-price]').html( Shopify.formatMoney(originalPrice) );
      jQuery('.product-header [savings-badge] span').html( Math.round( (productPrice / originalPrice)* 100) );
      jQuery('.product-header [original-price], .product-header [savings-badge]').removeClass('d-none');
    } else {
      jQuery('.product-header [original-price], .product-header [savings-badge]').addClass('d-none');
    }
  };

  function updateHistoryState() {
    var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variantObj.id;
    window.history.replaceState({path: newurl}, '', newurl);
  };

  var updateImage = function () {
    var variant_id = variantObj.id;
    var variant_image = variantObj.featured_image;
	var slider = $('#mip-carousel div.carousel-hero');
    if( slider && variant_image != null ) slider.slick('slickGoTo', parseInt(variant_image.position) -1);
  };

  function setVariant() {
    var variant = variantObj;
    var subscription_discount = Number(jQuery('#selling_plan_subscribe').data('discount') ) / 100;
    var subscription_selected = (jQuery('#selling_plan_subscribe').is(':checked'))?true:false;

    selectedVariantId = variant.id;
    jQuery('[variant-select] option').attr("selected",false);
    jQuery('[variant-select] option[value="'+ variant.id +'"]').attr("selected",true);

    document.dispatchEvent(new CustomEvent("variantChanged", { detail: { variantId: selectedVariantId } }));

    /* If subscription */
    if( subscription_selected ) {
      jQuery('#selling_plan_select').show();
      jQuery('[name="selling_plan"]').val( jQuery('select[name="selling_plan_choice"]').val() );
    /* If NOT subscription */
    } else {
      jQuery('#selling_plan_select').hide();
      jQuery('[name="selling_plan"]').val("");
    };

    // update UI items
    updatePrice(); // Updates display price and sale display
    updateImage();
  };

  function getCurrentVariant( variantId ) {
    var variants = productObj.variants;
	// map variants and return the selected one

    var found = jQuery.map(variants, function(variant) {
      if(variant.id == variantId) { return variant; }
    });
    return found[0]; // returns single array so pull out first element object
  };

  /* UI ITEMS */

  const mip = jQuery('#mip-carousel div.carousel-hero');
  mip.not('.slick-initialized').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    touchMove: false,
    arrows: true,
    dots: false,
    infinite: true,
    adaptiveHeight: true,
    asNavFor: '#mip-carousel-thumbs div.carousel-hero-thumbs',
  });

  const mipthumbs = jQuery('#mip-carousel-thumbs div.carousel-hero-thumbs');
  mipthumbs.not('.slick-initialized').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    touchMove: true,
    arrows: false,
    dots: false,
    infinite: true,
    focusOnSelect: true,
    adaptiveHeight: true,
    vertical: true,
    verticalSwapping: true,
    asNavFor: '#mip-carousel div.carousel-hero',
  });

  mip.on('beforeChange', function(event, slick, currentSlide, nextSlide){
    var currentVideo = jQuery(slick.$slides.get(currentSlide)).find('video');
    if(currentVideo.length > 0) { currentVideo[0].pause(); }
  });

  mip.on('afterChange', function(event, slick, currentSlide, nextSlide){
    var currentVideo = jQuery(slick.$slides.get(currentSlide)).find('video');
    if(currentVideo.length > 0) { currentVideo[0].play(); }
  });

  if( jQuery(".product-header [quantity-select]").length > 0 ){
   jQuery(".product-header [quantity-select]").inputSpinner();
  }

  jQuery('.option :radio').on('change', function () {
    var swatchElem = $(this).closest('.option-element');
    var optionVariantId = $(this).val();
    var optionIndex = $(this).closest('.swatch').attr('data-option-index');
    var optionIndexTarget = parseInt( optionIndex ) + 1;
    var optionValue = swatchElem.data('option-value');

    variantObj = getCurrentVariant( optionVariantId );
    jQuery('.option').removeClass('selected');
    jQuery(this).closest('.option').addClass('selected');

    setVariant();
    updateHistoryState(); // Adds Variant ID to URL for deeplinking
  });

  jQuery('[name="selling_plan_group"]').on('change', function () {
    jQuery('.selling-plan-fieldset .form-check').removeClass("selected");
    jQuery(this).parent().addClass("selected");
    setVariant();
  });

  jQuery('[name="selling_plan_choice"]').on('change', function () {
    setVariant();
  });

  jQuery('#upsell-popup-continue-button').on('click', function (evt) {
    evt.preventDefault();
	upsell_continue = true;
  });

  if(selectedVariantId){ setVariant(selectedVariantId); };
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !window.DesignMode) return;
  try {
    

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(productRecommendations);

      const url = productRecommendations.dataset.url;

      fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendations.innerHTML = recommendations.innerHTML;
        }
		MiniCart.bindUIActions();
      })
      .catch(e => {
        console.error(e);
      });

    };

    const productRecommendations = document.querySelector('.product-recommendations');
    const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
    observer.observe(productRecommendations);


  } catch(e) { console.error(e); }
})();
      })();
